/**
 * Input — themeable single-line text field (Claude Design `.input`):
 * 34px tall, `surface-2` fill, focus swaps to a `surface` fill with a
 * primary-line border.
 */
import { forwardRef, type InputHTMLAttributes } from 'react';

import { cn } from './cn.js';

export type InputProps = InputHTMLAttributes<HTMLInputElement>;

export const inputClasses =
  'w-full rounded-md border border-border bg-surface-2 px-[11px] text-[13px] leading-[1.4] text-text ' +
  'transition placeholder:text-faint ' +
  'focus-visible:outline-none focus:border-primary-line focus:bg-surface ' +
  'disabled:cursor-not-allowed disabled:opacity-50 ' +
  'aria-[invalid=true]:border-danger';

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => (
    <input
      ref={ref}
      type={type ?? 'text'}
      className={cn(inputClasses, 'h-[34px] py-2', className)}
      {...props}
    />
  ),
);
Input.displayName = 'Input';
